import React, { useEffect } from "react";
import "./App.css";
import { app, pages } from "@microsoft/teams-js";

export default function TabConfig() {
    useEffect(() => {
        app.initialize().then(() => {
            app.notifyAppLoaded();

            pages.config.registerOnSaveHandler((saveEvent) => {
                const baseUrl = `https://${window.location.hostname}:${window.location.port}`;
                pages.config.setConfig({
                    suggestedDisplayName: "ebuero",
                    entityId: "Test",
                    contentUrl: baseUrl + "/index.html#/tab",
                    websiteUrl: baseUrl + "/index.html#/tab",
                }).then(() => {
                    saveEvent.notifySuccess();
                });
            });

            pages.config.setValidityState(true);
            app.notifySuccess();
        });
    }, []);

    return (
        <div>
            <div>
                <p>
                    Hallo! Ich bin die ebuero App für Microsoft Teams. Mit der ebuero App können Sie jetzt auch Ihre Anrufnotizen direkt in Microsoft Teams erhalten. Bei Fragen und Anmerkungen können Sie auch gerne direkt mit unserem Kundenservice chatten.
                    Die ebuero Microsoft Teams App kann nur in Verbindung mit einem laufenden Kundenverhältnis bei der ebuero AG genutzt werden. Falls Sie noch kein Kunde sind, können Sie gerne unseren Telefonservice 14 Tage kostenfrei nutzen.
                </p>
                <a href="https://teams.microsoft.com/l/entity/fe7ba466-0cf5-43a6-bf5f-2d2e0dc73a0c/index0">Anmelden</a>&nbsp;<a href="https://www.ebuero.de/telefonservice/demo" target="_blank" rel="noreferrer">Demo-Anfrage</a>
            </div>
        </div>
    );
}
